import React, { ChangeEvent, useEffect, useRef } from 'react';

interface Props {
    value: string;
    inputType: string;
    onFocus: () => void;
    onBlur: () => void;
    onChange: (value: string) => void;
    maxChars: number;
    autoCapitalize: string | undefined;
    autoCorrect: string | undefined;
    onKeyDown?: (e?: React.KeyboardEvent<HTMLInputElement>) => void;
    autoFocus?: boolean;
    disabled?: boolean;
    tabIndex?: number;
    className: string;
}

export function Input({
    value,
    inputType,
    onFocus,
    onBlur,
    onChange,
    maxChars,
    autoCapitalize,
    autoCorrect,
    onKeyDown,
    autoFocus,
    disabled,
    tabIndex,
    className,
}: Props) {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (autoFocus) {
            inputRef.current?.focus();
        }
    }, [autoFocus]);

    function _onChange(e: ChangeEvent<HTMLInputElement>): void {
        const val = e.target.value;
        if (val.length <= maxChars) {
            onChange(val);
        }
    }

    function _onKeyDown(e: React.KeyboardEvent<HTMLInputElement>): void {
        if (onKeyDown) {
            onKeyDown(e);
        }
    }

    return (
        <input
            className={className}
            autoCorrect={autoCorrect || 'off'}
            autoCapitalize={autoCapitalize}
            ref={inputRef}
            value={value}
            type={inputType}
            onFocus={(): void => onFocus()}
            onBlur={(): void => onBlur()}
            onChange={(e: ChangeEvent<HTMLInputElement>): void => _onChange(e)}
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>): void =>
                _onKeyDown(e)
            }
            disabled={disabled}
            tabIndex={tabIndex !== undefined ? tabIndex : -1}
        />
    );
}
